export default {
  updateClient(state, data) {
    const clientIdx = state.clients.findIndex(
      (cliente) => cliente.id === data.clienteID
    );
    state.clients[clientIdx] = data;
  },

  setClients(state, data) {
    state.clients = data;
  },
};
